import { Typography } from "@mui/material";
import { useSelector } from "react-redux";

const SoapNoteView = ({ apntId, soapNote, isSurgery = false }) => {
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);

  const reqSoap = soapNote
    ? soapNote
    : isSurgery
    ? reqDet?.inpatientNotes?.find(
        (cn) =>
          cn?.appointmentId === apntId &&
          cn?.type === "surgery" &&
          cn?.consolidated
      ) ??
      reqDet?.inpatientNotes?.find(
        (cn) => cn?.appointmentId === apntId && cn?.type === "surgery"
      )
    : reqDet?.clinicalNotes?.find(
        (cn) => cn?.appointmentId === apntId && cn?.consolidated
      ) ??
      reqDet?.clinicalNotes?.find(
        (cn) => cn?.appointmentId === apntId && !cn?.consolidated
      );

  return apntId && reqSoap ? (
    isSurgery ? (
      <div className="mh20">
        <div className="fs14 blue-color font-bold mt10">
          Pre-Surgical Documentation
        </div>
        <Typography className="fs12 txt-regular black">
          {reqSoap?.preSurgicalDocumentation}
        </Typography>
        <div className="fs14 blue-color font-bold mt10">
          Intra-Surgical Documentation
        </div>
        <Typography className="fs12 txt-regular black">
          {reqSoap?.intraSurgicalDocumentation}
        </Typography>
        <div className="fs14 blue-color font-bold mt10">
          Post-Surgical Documentation
        </div>
        <Typography className="fs12 txt-regular black">
          {reqSoap?.postSurgicalDocumentation}
        </Typography>
        <div className="fs14 blue-color font-bold mt10">
          Owner Communication
        </div>
        <Typography className="fs12 txt-regular black">
          {reqSoap?.ownerCommunication}
        </Typography>
        <div className="fs14 blue-color font-bold mt10">
          Additional Documentation
        </div>
        <Typography className="fs12 txt-regular black">
          {reqSoap?.additionalDocumentation}
        </Typography>
      </div>
    ) : (
      <div className="mh20">
        <div className="fs14 blue-color font-bold mt10">
          Diagnosis: {reqSoap?.tag ?? ""}
        </div>
        <div className="fs14 blue-color font-bold mt10">Subjective</div>
        <Typography className="fs12 txt-regular black">
          {reqSoap?.subjective}
        </Typography>
        <div className="fs14 blue-color font-bold mt10">Objective</div>
        <Typography className="fs12 txt-regular black">
          {reqSoap?.objective}
        </Typography>
        <div className="fs14 blue-color font-bold mt10">Assessment</div>
        <Typography className="fs12 txt-regular black">
          {reqSoap?.assessment}
        </Typography>
        <div className="fs14 blue-color font-bold mt10">Plan</div>
        <Typography className="fs12 txt-regular black">
          {reqSoap?.plan}
        </Typography>
      </div>
    )
  ) : null;
};

export default SoapNoteView;
